import { FC, useEffect } from 'react';
import useSurveyNavigate from '@/hooks/useSurveyNavigate';
import SurveyDefaultStep from '@/components/SurveyDefaultStep';
import PhoneImage from '@/assets/images/phone.png';
import analytics from '@/utils/analytics/analyticsInstance';

const PersonalizePage: FC = () => {
  const { next } = useSurveyNavigate();

  useEffect(() => {
    analytics.track('webOnboardingScreenOpened', {
      screen_title: 'Let’s personalize your shopping feed',
    });
  }, []);

  return (
    <SurveyDefaultStep
      title={{ value: 'Let’s personalize your shopping feed' }}
      subTitle={{ value: 'See only what matches your taste — and earn rewards as you go.' }}
      image={PhoneImage}
      button={{ onClick: next }}
    />
  );
};

export default PersonalizePage;
